import React, { useEffect, useRef, useState } from "react";
import DataTable from "./DataTable";
import {
  getTasksToApprove,
  taskApproveOrRejcet,
  getdropdowncities,
  getdropdowntaskname,
  reassigntask,
  getdrawedetails,
} from "./apis";
import { useLocation, useNavigate } from "react-router-dom";
import TaskModal from "./TaskModal";
import { getToken } from "../../utils/utils";

import {
  Box,
  InputAdornment,
  Link,
  Tab,
  Tabs,
  TextField,
  Typography,
  Button,
  Pagination,
  PaginationItem,
  CircularProgress,
} from "@mui/material";
import serachicon from "../../../src/assests/images/search_icon.svg";
import Reportdropdown from "../reports/Reportdropdown";
import arrowleft from "../../../src/assests/images/arrow_left.svg";
import { useDebounce } from "use-debounce";

import ApprovalDrawer from "./ApprovalDrawer";
import pack from "../../../src/assests/images/pack1.svg";
import pack2 from "../../../src/assests/images/pack2.svg";
import Tasks from "../tasks/Tasks";
import { format } from "date-fns";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

interface TaskQuestion {
  question_id: number;
  question_en: string;
  sample_picture: string;
  task_question_answer?: { answer: string } | null;
}
interface IDrawDetails {
  qutiondetails: TaskQuestion[]
}



interface TasksData {
  pmi_entity_code?: string;
  task_en?: string;
  action?: {
    task?: {
      task_questions?: any;

    };
  };


}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ py: 1, my: 1 }}>{children}</Box>}
    </div>
  );

}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const status = ["in_progress", "rejected", "approved", 'verified_by_pmi'];
type Task = {
  id: null | undefined;
  pmi_entity_code: string;
};
interface TasksApprovalProps {
  filterdatawww: any;
}

interface dsdfsdf {
  pmi_entity_code: any;
  task_en: any;
}

const TasksApproval: React.FC = () => {


  const navigate = useNavigate();

  const [tasksData, settasksData] = useState<Task[]>([]);
  const [totals, setTotals] = useState({
    in_progress: 0,
    rejected: 0,
    approved: 0,

    verified_by_pmi: 0
  });
  const [page, setPage] = useState(1);
  const location = useLocation();
  const [isLoading, setIsLoading] = useState(true);

  const [locValue1, setLocValue1] = useState<null | string>(null);;

  const [showDetails, setShowDetails] = useState(null);
  const token = getToken();
  const [searchTerm, setSearchTerm] = useState("");
  const [value, setValue] = useState(0);
  const [totalcount, settotalcount] = useState(0);

  // const [selectedLocation, setSelectedLocation] = useState("");
  const [selectedLocation, setSelectedLocation] = useState<string[]>([]);

  // const [selectedtask, setSelectedtask] = useState("");
  const [selectedtask, setSelectedTask] = useState<string[]>([]);

  const [SelectedTaskId, setSelectedTaskId] = useState<string[]>([]);

  const [dropdowncities, setdropdowncities] = useState<any[]>([]);

  const [dropdowntaskname, setdropdowntaskname] = useState<any[]>([]);

  const [debouncedSearchTerm] = useDebounce(searchTerm, 500);

  const [refreshKey, setRefreshKey] = useState<number>(0);

  const perpagedata = 10;

  const reportDropdownOptions1 = [
    { value: "Task", label: "Task" },
    { value: "Task 1", label: "Task 1" },
    { value: "Task 2", label: "Task 2" },
  ];


  const [totalcount11, settotalcount11] = useState({ in_progress: 0, verified_by_pmi: 0, approved: 0, rejected: 0 });

  const [totalcount12, settotalcount12] = useState({ in_progress: 0, verified_by_pmi: 0, approved: 0, rejected: 0 });
  const [totalcounapprove, settotaapprove] = useState("");
  const [totalcountrejected, settotrejected] = useState("");
  const [totalcountverify, settotverify] = useState(false);
  const [tasksDataopen1, settasksDataopen] = useState("");

  useEffect(() => {
    if (location.state?.totalcount122a) {
      console.log(location.state?.totalcount122a, "location.state?.selectedIddddddddddd")
      settotalcount11(location.state.totalcount122a);
    }
  }, [location.state]);
  console.log(totalcount11, "totalcount11totalcount11totalcount11")

  useEffect(() => {
    if (isLoading) {
      setLocValue1(null); // Reset locValue1 when isLoading is true
    } else {
      // Do nothing when isLoading is false, no restoration
    }
  }, [isLoading])


  useEffect(() => {
    if (location.state?.tasksDataopen) {
      console.log(location.state?.tasksDataopen, "location.state?.tasksDataopen")
      settasksDataopen(location.state.tasksDataopen);
    }
  }, [location.state]);

  console.log(tasksDataopen1, "tasksDataopen1wwwwwwwwwwww")

  useEffect(() => {
    if (location.state?.tasksDataee445) {
      console.log(location.state?.tasksDataee445, "location.state?.tasksDataee445tasksDataee445")
      // settotalcount11(location.state.tasksDataee445);
    }
  }, [location.state]);

  useEffect(() => {
    if (location.state?.tasksDatatasksData213) {
      console.log(location.state?.tasksDatatasksData213, "location.state?.tasksDatatasksData213tasksDatatasksData213")
      // settotalcount11(location.state.tasksDataee445);
    }
  }, [location.state]);


  useEffect(() => {
    if (location.state?.totalcount122a45) {
      console.log(location.state?.totalcount122a45, "location.state?.totalcount122a45totalcount122a45")
      settotalcount12(location.state.totalcount122a45);
    }
  }, [location.state]);



  useEffect(() => {
    if (location.state?.totalcount122a45) {
      console.log(location.state?.totalcount122a45, "location.state?.totalcount122a45totalcount122a45")
      settotalcount12(location.state.totalcount122a45);
    }
  }, [location.state]);

  const [tasksDatadsfs, settasksDataere] = useState<Task[]>([]);

  useEffect(() => {
    if (location.state?.taskRejecteddata) {
      console.log(location.state?.taskRejecteddata, "taskRejecteddatataskRejecteddata")
      settotrejected(location.state.taskRejecteddata);
    }
  }, [location.state]);







  useEffect(() => {
    if (location.state?.isSubmittedverify55) {
      console.log(location.state?.isSubmittedverify55, "isSubmittedverify55isSubmittedverify55");
      settotverify(location.state.isSubmittedverify55);


      const timer = setTimeout(() => {
        settotverify(false);
      }, 2000);


      return () => clearTimeout(timer);
    }
  }, [location.state]);


  useEffect(() => {
    if (location.state?.taskApproval) {
      console.log(location.state?.taskApproval, "dsfkdnfkjndkfj")
      settotaapprove(location.state.taskApproval);
    }
  }, [location.state]);


  useEffect(() => {
    if (location.state?.tasksDatatasksDffdata213) {
      console.log(location.state?.tasksDatatasksDffdata213, "location.state?.tasksDatatasksDffdata213")
      settasksDataere(location.state.tasksDatatasksDffdata213);
    }
  }, [location.state]);






  const pageIndex = page;
  const limit = Number(perpagedata);
  useEffect(() => {
    const fetchTasks = async () => {
      setIsLoading(true);

      const queryParams = {
        status: status[value],
        location: selectedLocation || "",
        task_id: selectedtask || "",
        search: debouncedSearchTerm || "",
        page: pageIndex.toString(),
        limit: limit.toString(),
      };

      try {
        const res = await getTasksToApprove(
          token,
          queryParams.status,
          queryParams.search,
          queryParams.page,
          queryParams.limit,
          queryParams.location,
          queryParams.task_id
        );

        if (res.status) {
          console.log(res.data?.data, "res.data?.data?");

          const filteredData = res.data?.data?.map((item: { [x: string]: any; id: any; pmi_entity_code: any; outlet_name: any; approval_status: any; remarks: any; locations: any; reassign_account_length: any; verified_by_pmi: any; updated_at: string | number | Date; }) => ({
            id: item.id,
            pmi_entity_code: item.pmi_entity_code || "",
            task_en: item["task.task_en"] || "",
            task_type_en: item["task.task_type_en"] || "",
            outlet_name: item.outlet_name || "",
            approval_status: item.approval_status || "",
            remarks: item.remarks || "",
            locations: item.locations,
            approved_by: item.approved_by,
            reassign_account_length: item.reassign_account_length,
            verified_by_pmi: item.verified_by_pmi || "",
            updated_at: item.updated_at
              ? format(new Date(item.updated_at), "dd MMM yyyy")
              : "",
            verifiedapproveddate: item.appveddateofverifed,
            action: item,
          })) || [];

          settasksData(filteredData);


          setTotals(
            res.data?.totals || {
              in_progress: 0,
              rejected: 0,
              approved: 0,
              verified_by_pmi: 0,
            }
          );

          settotalcount(res.data?.totals?.[status[value]] || 0);
        } else {
          settasksData([]);
          setTotals({ in_progress: 0, rejected: 0, approved: 0, verified_by_pmi: 0 });
        }
      } catch (err) {
        console.error("Error fetching tasks:", err);
        settasksData([]);
        setTotals({ in_progress: 0, rejected: 0, approved: 0, verified_by_pmi: 0 });
      } finally {
        setIsLoading(false);
      }
    };

    fetchTasks();
  }, [
    value,
    debouncedSearchTerm,
    page,
    selectedLocation,
    selectedtask,
    limit,
    token,
    status,
  ]);



  console.log(totalcountverify, "totalcountverifytotalcountverify")

  console.log(isLoading, "isLoadingisLoadingisLoading")


  useEffect(() => {
    if (totalcounapprove || totalcountrejected || totalcountverify) {

      const fetchTasks = async () => {
        setIsLoading(true);

        const queryParams = {
          status: status[value],
          location: selectedLocation || "",
          task_id: selectedtask || "",
          search: debouncedSearchTerm || "",
          page: pageIndex.toString(),
          limit: limit.toString(),
        };

        try {
          const res = await getTasksToApprove(
            token,
            queryParams.status,
            queryParams.search,
            queryParams.page,
            queryParams.limit,
            queryParams.location,
            queryParams.task_id
          );

          if (res.status) {
            console.log(res.data?.data, "res.data?.data?");

            const filteredData =
              res.data?.data?.map(
                (item: {
                  id: any;
                  pmi_entity_code: any;
                  outlet_name: any;
                  approval_status: any;
                  remarks: any;
                  locations: any;
                  reassign_account_length: any;
                  verified_by_pmi: any;
                  approved_by: any;
                  updated_at: string | number | Date;
                  [key: string]: any;
                }) => ({
                  id: item.id,
                  pmi_entity_code: item.pmi_entity_code || "",
                  task_en: item["task.task_en"] || "",
                  task_type_en: item["task.task_type_en"] || "",
                  outlet_name: item.outlet_name || "",
                  approval_status: item.approval_status || "",
                  remarks: item.remarks || "",
                  locations: item.locations,
                  reassign_account_length: item.reassign_account_length,
                  verified_by_pmi: item.verified_by_pmi,
                  approved_by: item.approved_by,
                  updated_at: item.updated_at
                    ? format(new Date(item.updated_at), "dd MMM yyyy")
                    : "",
                  verifiedapproveddate: item.appveddateofverifed,
                  action: item,
                })
              ) || [];

            settasksData(filteredData);

            setTotals(
              res.data?.totals || {
                in_progress: 0,
                rejected: 0,
                approved: 0,
                verified_by_pmi: 0,
              }
            );

            settotalcount(res.data?.totals?.[status[value]] || 0);
          } else {
            settasksData([]);
            setTotals({
              in_progress: 0,
              rejected: 0,
              approved: 0,
              verified_by_pmi: 0,
            });
          }
        } catch (err) {
          console.error("Error fetching tasks:", err);
          settasksData([]);
          setTotals({
            in_progress: 0,
            rejected: 0,
            approved: 0,
            verified_by_pmi: 0,
          });
        } finally {
          setIsLoading(false);
        }
      };

      fetchTasks();
    }
  }, [
    value,
    debouncedSearchTerm,
    pageIndex,
    selectedLocation,
    selectedtask,
    limit,
    token,
    status,
    totalcounapprove,
    totalcountrejected,
    totalcountverify
  ]);


  console.log(totalcountverify, "totalcountverifyeeeeeeeeeeee")



  const filteredData =

    useEffect(() => {
      const fetchdropdowncities = async () => {
        try {
          const response = await getdropdowncities();
          const cities = response.data.data || [];
          setdropdowncities(
            cities.map((city: string) => ({ value: city, label: city }))
          );
        } catch (error) {
          console.error("Error fetching cities:", error);
        }
      };

      fetchdropdowncities();
    }, []);
  console.log(refreshKey, "refreshKeyrefreshKeyrefreshKeyrefreshKey")
  useEffect(() => {
    const fetchdropdowntaskname = async () => {
      try {
        const response = await getdropdowntaskname();
        const taskname = response.data.data || [];
        setdropdowntaskname(
          taskname.map((city: { value: string; label: string }) => ({
            value: city.value,
            label: city.label,
          }))
        );
      } catch (error) {
        console.error("Error fetching taskname:", error);
      }
    };

    fetchdropdowntaskname();
  }, []);

  const handleApproveOrReject = async (
    accountId: string,
    task_id: string,
    status: "approved" | "rejected",
    remarks: string | null
  ) => {
    const reqBody = {
      accountId,
      task_id,
      status,
      remarks,
    };
    await taskApproveOrRejcet(reqBody, token);

    window.location.reload();

  };



  // const handleLocationChange = (
  //   selected: { value: string; label: string } | null
  // ) => {
  //   console.log(selected);
  //   if (selected) {
  //     setSelectedLocation(selected.value);
  //   } else {
  //     setSelectedLocation("");
  //   }
  // };

  const handleLocationChange = (selectedOptions: { value: string; label: string }[] | null) => {
    setSelectedLocation(selectedOptions ? selectedOptions.map(option => option.value) : []);
  };

  const handleTaskChange = (selectedOptions: { value: string; label: string }[] | null) => {
    setSelectedTask(selectedOptions ? selectedOptions.map(option => option.value) : []);
  };

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {

    setValue(newValue);
  };

  const handleActionClick = (row: any) => {

    setShowDetails(row);
  };

  let columns = [
    { field: "pmi_entity_code", headerName: "PMI Entity Code", type: "string" },
    { field: "outlet_name", headerName: "Outlet Name", type: "string" },
    { field: "task_type_en", headerName: "Task Type", type: "string" },
    { field: "task_en", headerName: "Task Name", type: "string" },
    { field: "locations", headerName: "Locations", type: "string" },

  ];


  if (value === 0) {

    columns.push({ field: "reassign_account_length", headerName: "Reassign Count", type: "string" });
    columns.push({ field: "action", headerName: "Task Details", type: "action" });
  }


  if (value === 3) {
    columns.push({ field: "verifiedapproveddate", headerName: "Approved Date", type: "string" });
    columns.push({ field: "verified_by_pmi", headerName: "verified by", type: "string" });

    columns = columns.filter(
      (column) => column.field !== "action" && column.field !== "reassign_account_length"
    );
  }

  if (value === 2) {
    columns.push({ field: "updated_at", headerName: "Approved Date", type: "string" });
    columns.push({ field: "approved_by", headerName: "Approved By", type: "string" });
    columns.push({ field: "action", headerName: "Verify Approval", type: "action" });
    columns = columns.filter(
      (column) => column.field !== "reassign_account_length"
    );

  }

  if (value === 1) {

    columns.push({ field: "updated_at", headerName: "Rejected Date", type: "string" });

    columns.push({ field: "remarks", headerName: "Rejected Reason", type: "string" });
    columns.push({ field: "action", headerName: "Reassign Task", type: "Rejected Icon" });

    columns = columns.filter(
      (column) => column.field !== "reassign_account_length"
    );

  }
  console.log(totals, "totalcounttotalcounttotalcount")

  console.log(totalcount, "totalcounttotalcount222")
  let totalcount1 = 0;
  console.log(totalcount11?.in_progress, "totalcount11?.in_progress")
  console.log(totalcount11, "totalcount11totalcount112222222")
  if (value === 0) {
    totalcount1 = totalcount11?.in_progress !== 0 ? totalcount11?.in_progress : totalcount12?.in_progress !== 0 ? totalcount12?.in_progress : totals.in_progress;
  } else if (value === 1) {
    totalcount1 = totalcount11?.rejected !== 0 ? totalcount11?.rejected : totalcount12?.rejected !== 0 ? totalcount12?.rejected : totals.rejected;
  } else if (value === 2) {
    totalcount1 = totalcount11?.approved !== 0 ? totalcount11?.approved : totalcount12?.approved !== 0 ? totalcount12?.approved : totals.approved;
  } else if (value === 3) {
    totalcount1 = totalcount11?.verified_by_pmi !== 0 ? totalcount11?.verified_by_pmi : totalcount12?.verified_by_pmi !== 0 ? totalcount12?.verified_by_pmi : totals.verified_by_pmi;
  }


  const totalPages = Math.ceil(totalcount1 / perpagedata);
  console.log(totalPages, "totalPagestotalPages")
  console.log(
    JSON.stringify(tasksData.map(item => item.pmi_entity_code), null, 2),
    "tasksDatatasksDatatasksData"
  );






  useEffect(() => {
    if (location.state?.tasksselectedIdee) {
      console.log(location.state, "location.state");
      console.log(location.state?.tasksselectedIdee, "location.state?.tasksselectedIdee");


      if (isLoading) {
        setLocValue1(null);
      } else {
        setLocValue1(location.state.tasksselectedIdee);
      }
    }
  }, [location.state, isLoading]);





  console.log(
    JSON.stringify(locValue1, null, 2),
    "locValuelocValuelocValue88888"
  )


  console.log(
    JSON.stringify(tasksData, null, 2),
    "tasksDataoo000"
  )

  const finaldata = tasksData.filter(item => item.id === locValue1)
  console.log(finaldata, "uuuuuuuuuuuuuuuu")
  console.log(locValue1, "locValue1ddddddddddddd")

  const [drawDetails, setDrawDetails] = useState<IDrawDetails>({ qutiondetails: [] });
  console.log(tasksDataopen1, "tasksDataopen1tasksDataopen1")
  useEffect(() => {
    // Only trigger the API call if tasksDataopen1 is not empty and locValue1 is set
    if (!locValue1) return;

    const fetchTasksdetails11 = async () => {
      try {
        const res = await getdrawedetails({ usertaskid: locValue1 }, token);
        console.log('resultq', res)
        setDrawDetails(res.data.data);
      } catch (error) {
        console.error("Error fetching task details:", error);
      }
    };

    fetchTasksdetails11();
  }, [locValue1, token]); // ✅ Runs only when locValue1 or token changes


  console.log(drawDetails, "drawDetailsdrawDetails")
  const prevSelectedlocations = useRef(tasksData);
  useEffect(() => {
    if (
      tasksData !== null &&
      JSON.stringify(tasksData) !==
      JSON.stringify(prevSelectedlocations.current)
    ) {
      console.log(
        tasksData,
        "selectedLocations55"
      );
      navigate(`/tasks-approval`, {
        state: { tasksDatatasksDatatasksData22: tasksData },
      });
      prevSelectedlocations.current = tasksData;
    }
  }, [tasksData]);








  console.log(
    JSON.stringify(finaldata, null, 2),
    "0000000000008887776666"
  )



  type Task = {
    tabname: any;
    action: any;
    id: null | undefined;
    pmi_entity_code: string;
    task_en: string;
  };

  // useEffect{
  //   if(tasksDataopen1){
  //     try{

  //     }
  //   }
  // }

  console.log(finaldata, "finaldatafinaldatafinaldata")
  const drawerData = [
    {
      header: "Approval Details",
      dynamictexts: [
        {
          label: "PMI Entity Code:",
          span: finaldata?.map((item: Task) => item.pmi_entity_code) || "N/A",
        },
        {
          label: "Task Name:",
          span: finaldata?.map((item: Task) => item.task_en) || "N/A",
        },
      ],
      sidehead: "Images",
      gridcard: drawDetails.qutiondetails.length > 0
        ? drawDetails.qutiondetails?.flatMap((item, index) => {
          console.log(JSON.stringify(item, null, 2), "Processing item:");

          return [
            {
              label: `Sample ${index + 1}:`,
              span: item.question_en || "No Question",
              src: item.sample_picture
                ? `${process.env.REACT_APP_API_URL}${item.sample_picture}`
                : "No Image",
              bgColor: index % 2 === 0 ? "rgba(241, 242, 243, 1)" : "#FFF",
              labelColor: index % 2 === 0 ? "rgba(29, 41, 57, 1)" : "rgba(73, 74, 75, 1)",
              spanColor: index % 2 === 0 ? "rgba(29, 41, 57, 1)" : "#000",
            },
            {
              label: `Clickable ${index + 1}:`,
              span: item.question_en || "No Question",
              src: item.task_question_answer?.answer || "No Answer",
              bgColor: index % 2 === 0 ? "rgba(241, 242, 243, 1)" : "#FFF",
              labelColor: index % 2 === 0 ? "rgba(29, 41, 57, 1)" : "rgba(73, 74, 75, 1)",
              spanColor: index % 2 === 0 ? "rgba(29, 41, 57, 1)" : "#000",
            },
          ];
        })
        : [],
      rejectdynamictexts: [
        {
          label: "PMI Entity Code:",
          span: finaldata?.map((item: Task) => item.pmi_entity_code) || "N/A",
        },
        {
          label: "Task Name:",
          span: finaldata?.map((item: Task) => item.task_en) || "N/A",
        },
      ],
      rejectheader: "Availability Tasks",
      rejected: "Rejected",
      idApproved: `${finaldata?.map((item: Task) => item.pmi_entity_code) || "N/A"
        } Task Successfully Approved`,
    },
  ];
  console.log('drawDetails', drawDetails)
  console.log(drawerData, "drawerData")

  console.log(value)
  useEffect(() => {
    if (value) {
      navigate(`/tasks-approval`, { state: { valuetabsdata: value } });
    }
  }, [value]);

  console.log(totalcount12, "totalcount12totalcount12totalcount12")

  console.log(value, "value444444444444444")
  useEffect(() => {
    if (tasksDatadsfs.length > 0) {
      if (tasksDatadsfs.some(item => item.tabname === 'approved')) {
        // setValue(2);
      } else if (tasksDatadsfs.some(item => item.tabname === 'rejected')) {
        // setValue(1);
      }
    }
  }, [tasksDatadsfs]);

  console.log(value, "rrrrrrrrrrrrrrreeeeeeeeeeeeee")

  const prevSelectedLocations = useRef<number | null>(null);
  useEffect(() => {
    if (
      JSON.stringify(value) !== JSON.stringify(prevSelectedLocations.current)
    ) {
      console.log(value, "selectedLocations5fdfdfdfdfdffd5");
      navigate(`/tasks-approval`, {
        state: { selectedDatevaluevaluefdgfg: value },
      });
      prevSelectedLocations.current = value; // Corrected variable name
    }
  }, [value, navigate]);

  return (
    <div>

      <Box sx={{ width: "100%" }}>
        
        <Box sx={{ padding: "24px 32px 0", background: "#fff " }}>
          {value === 2 && (
            <>
            
              <Link
                href="/tasks-approval"
                sx={{
                  textDecoration: "none",
                  fontSize: "14px",
                  fontWeight: "500",
                  color: "rgba(105, 106, 107, 1)",
                }}
              >
                Tasks /
              </Link>
              <Link
                sx={{
                  textDecoration: "none",
                  fontSize: "14px",
                  fontWeight: "600",
                  color: "rgba(142, 2, 15, 1)",
                }}
              >
                Approval

              </Link>

            </>
          )}

          <Typography
            variant="h3"
            sx={{
              fontSize: "24px",
              fontWeight: "600",
              color: "#000",
              marginTop: "16px",
            }}
          >
            Tasks For Approval
          </Typography>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              gap: "12px"
            }}
          >
            <TextField
              required
              placeholder="Search by Task, PMI Entity Code, Outlet Name & Location"
              sx={{
                ".MuiOutlinedInput-root": {
                  borderRadius: "12px",
                  height: "48px",
                  width: "521px",
                },
              }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <img src={serachicon} alt="search icon" width="18" />
                  </InputAdornment>
                ),
              }}
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />

            <Box
              className="task-approval-dropdown-maxwidth"
              sx={{
                display: "flex",
                alignItems: "center",
                gap: "16px",
                margin: "24px 20px",
                maxWidth: "290px"
              }}
            >
              <Reportdropdown
                options={[
                  { value: "", label: "All Tasks" },
                  ...dropdowntaskname,
                ]}
                placeholder="Task Name"
                value={selectedtask}
                onChange={handleTaskChange}
              />

              <Reportdropdown
                options={[
                  { value: "", label: "All Locations" },
                  ...dropdowncities,
                ]}
                placeholder="All Locations"
                value={selectedLocation}
                onChange={handleLocationChange}
              />
            </Box>
          </Box>
          <Box>
            <Tabs

              sx={{
                ".MuiTabs-indicator": {
                  backgroundColor: "rgba(200, 23, 47, 1)",
                  height: "3px",
                },
              }}
              value={value}
              onChange={handleChange}
              aria-label="basic tabs example"
            >
              <Tab
                sx={{
                  "&.MuiButtonBase-root": {
                    color: "rgba(73, 74, 75, 1)",
                    fontSize: "16px",
                    fontWeight: "500",
                    lineHeight: "17px",
                    padding: "0px",
                    marginRight: "16px",
                    textTransform: "capitalize",
                  },
                  "&.Mui-selected": { color: "#000", fontWeight: "600" },
                }}
                label={`Pending (${totalcount11?.in_progress !== 0 ? totalcount11?.in_progress : totalcount12?.in_progress !== 0 ? totalcount12?.in_progress : totals["in_progress"]
                  })`}
                {...a11yProps(0)}
              />
              <Tab
                sx={{
                  "&.MuiButtonBase-root": {
                    color: "rgba(73, 74, 75, 1)",
                    fontSize: "16px",
                    fontWeight: "500",
                    lineHeight: "17px",
                    padding: "0px",
                    marginRight: "16px",
                    textTransform: "capitalize",
                  },
                  "&.Mui-selected": { color: "#000", fontWeight: "600" },
                }}
                // label={`Rejected (${totals["rejected"]})`}
                label={`Rejected (${totalcount11?.rejected !== 0 ? totalcount11?.rejected : totalcount12?.rejected !== 0 ? totalcount12?.rejected : totals["rejected"]
                  })`}
                {...a11yProps(1)}
              />
              <Tab
                sx={{
                  "&.MuiButtonBase-root": {
                    color: "rgba(73, 74, 75, 1)",
                    fontSize: "16px",
                    fontWeight: "500",
                    lineHeight: "17px",
                    padding: "0px",
                    marginRight: "16px",
                    textTransform: "capitalize",
                  },
                  "&.Mui-selected": { color: "#000", fontWeight: "600" },
                }}
                // label={`Approved (${totals["approved"]})`}
                label={`Approved (${totalcount11?.approved !== 0 ? totalcount11?.approved : totalcount12?.approved !== 0 ? totalcount12?.approved : totals["approved"]
                  })`}
                {...a11yProps(2)}
              />


              <Tab
                sx={{
                  "&.MuiButtonBase-root": {
                    color: "rgba(73, 74, 75, 1)",
                    fontSize: "16px",
                    fontWeight: "500",
                    lineHeight: "17px",
                    padding: "0px",
                    marginRight: "16px",
                    textTransform: "capitalize",
                  },
                  "&.Mui-selected": { color: "#000", fontWeight: "600" },
                }}
                // label={`Verified by pmi (${totals["verified_by_pmi"]})`}

                label={`Verified by PMI  (${totalcount11?.verified_by_pmi !== 0 ? totalcount11?.verified_by_pmi : totalcount12?.verified_by_pmi !== 0 ? totalcount12?.verified_by_pmi : totals["verified_by_pmi"]
                  })`}
                {...a11yProps(3)}
              />


            </Tabs>
          </Box>
        </Box>

        {["in_progress", "rejected", "approved", "verified_by_pmi"].map((_, idx) => (
          <CustomTabPanel value={value} index={idx} key={idx}>
            <DataTable
              columns={columns}
              rows={tasksData}
              // rows={(tasksDatadsfs && tasksDatadsfs.length > 0 ? tasksDatadsfs : tasksData)} 
              onActionClick={handleActionClick}
              loading={isLoading}
              drawerData={drawerData}
              selectedLocation={selectedLocation}
              SelectedTaskId={SelectedTaskId}
              debouncedSearchTerm={debouncedSearchTerm}
              pageindex={pageIndex.toString()}
              limit={limit.toString()}
              value11={value}
              finaldata22={finaldata}
            />
          </CustomTabPanel>
        ))}
        <Box sx={{ background: "#fff", margin: "0 32px", boxShadow: "-1px 1px 1px #e7e8e9", border: "2px solid rgba(231, 232, 233, 1)", borderTop: "0", padding: "5px 0", borderBottomLeftRadius: "10px", borderBottomRightRadius: "10px", marginBottom: "50px" }}>
          {!isLoading && tasksData.length > 0 ? (
            <Pagination
              count={totalPages}
              page={page}
              onChange={(event, value) => setPage(value)}
              renderItem={(item) => (
                <PaginationItem
                  components={{
                    previous: () => (
                      <Button
                        variant="contained"
                        sx={{
                          backgroundColor: "transparent",
                          border: "1px solid rgba(208, 213, 221, 1)",
                          borderRadius: "8px",
                          boxShadow: "none",
                          fontSize: "14px",
                          fontWeight: "500",
                          color: "#000",
                          textTransform: "capitalize",
                          opacity: item.disabled ? "0.5" : "1",
                        }}
                      >
                        <img
                          style={{ marginRight: "12px" }}
                          src={arrowleft}
                          alt="Previous"
                        />
                        Previous
                      </Button>
                    ),
                    next: () => (
                      <Button
                        variant="contained"
                        sx={{
                          backgroundColor: "transparent",
                          border: "1px solid rgba(208, 213, 221, 1)",
                          borderRadius: "8px",
                          boxShadow: "none",
                          fontSize: "14px",
                          fontWeight: "500",
                          color: "#000",
                          textTransform: "capitalize",
                          opacity: item.disabled ? "0.5" : "1",
                        }}
                      >
                        Next
                        <img
                          style={{
                            marginLeft: "12px",
                            transform: "rotate(180deg)",
                          }}
                          src={arrowleft}
                          alt="Next"
                        />
                      </Button>
                    ),
                  }}
                  {...item}
                />
              )}
              sx={{
                "li:first-of-type": { position: "absolute", left: "10px" },
                "li:last-of-type": { position: "absolute", right: "10px" },
                position: "relative",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                padding: "16px 0",
                ".Mui-selected": {
                  backgroundColor: "rgba(245, 251, 255, 1) !important",
                  borderRadius: "8px",
                  color: "rgba(87, 163, 253, 1)",
                  fontWeight: "500",
                  ".MuiPaginationItem-text": {
                    fontSize: "14px !important",
                    fontWeight: "500",
                  },
                },
              }}
            />
          ) : (
            <Typography variant="h6" sx={{ textAlign: "center", color: "gray" }}>
              No data found
            </Typography>
          )}
        </Box>

        <TaskModal
          open={!!showDetails}
          onClose={() => setShowDetails(null)}
          tasksData={showDetails}
          onApprove={handleApproveOrReject}
          onReject={handleApproveOrReject}
        />
      </Box>
    </div>
  );
}

export default TasksApproval;